/**
 * Removes all non-digit characters from an array of barcodes.
 *
 * @param {Array<string>} barcodes - The array of barcodes to be cleaned.
 * @returns {Array<string>} - A new array with only the numeric characters from the original barcodes.
 *
 * @example
 * // Returns ['123456', '7890', '456789']
 * getValidBarCodes(['123-456', '78-90', '4-5-6-7-8-9'])
 */
export function getValidBarCodes(barcodes: Array<string>): Array<string> {
  return barcodes.map((code: string) => code.replace(/\D/g, ''))
}
